import baseApi from "@/api/baseApi";

export default {
  fetchReportData(form) {
    return baseApi.post('api-ear-marks/api/order-accounting/v1/invoice', form);
  },
  save(form) {
    return baseApi.put('api-ear-marks/api/order-accounting/v1/invoice', form);
  }
}
